export const RUI_DIALOG_HOST_ID = "__rui-dialog-host";
export const RUI_DIALOG_OPEN_EVENT = "rui-dialog-open";
export const RUI_DIALOG_CLOSE_EVENT = "rui-dialog-close";
export const RUI_DIALOG_TOGGLE_EVENT = "rui-dialog-toggle";
export const RUI_DIALOG_ACTION_EVENT = "rui-dialog-action";
export function isNamedDialogOpen(detail) {
  return "id" in detail && detail.id != null && detail.id !== "";
}